import { PollVote, PollVoteUpdate } from "@virtualprogaming/js-public-sdk";
import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { POLL_BY_ID } from "~/constants/react-query-keys/poll";

import { usePollApi } from "./usePollApi";

export function useUpdatePollVote(
  options?: UseMutationOptions<
    AxiosResponse<PollVote>,
    unknown,
    [number, PollVoteUpdate]
  >
) {
  const api = usePollApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((rq) => api.updateVote(...rq), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries([POLL_BY_ID]);
    },
    ...rest,
  });
}
